import { Subscription } from 'rxjs';
import { MediaPlayerFileSystem } from 'src/mediaPlayerFileSystem';
import { HtmlUtils } from 'src/htmlUtils';
import { FileUtils } from 'src/fileUtils';


export class TickerFontManager {

    private fontWatchers: Subscription[] = [];

    private nameLookup : {[key:string]:string} = {};

    public constructor(
        private readonly styleElementId: string,
        private readonly sourceFolder: string,
        private mediaPlayerFileSystem: MediaPlayerFileSystem
    ) {

    }

    public dispose() : void {
        this.fontWatchers.forEach(
            fontWatcher => fontWatcher.unsubscribe()
        );

        this.fontWatchers.splice(0, this.fontWatchers.length);
    }

    // This method will add the font file to the stylesheet (if it is not there already)
    // and return the family name to refer to the font with
    public ensureFontFamilyIsInStyleSheet(fontFileName: string) : string {
        if (fontFileName in this.nameLookup) {
            return this.nameLookup[fontFileName];
        }
        const generatedName = `ticker_font_${HtmlUtils.generateUniqueId()}`;
        this.nameLookup[fontFileName] = generatedName;
        const fontFilePath = FileUtils.getFeedFilePath(fontFileName, this.sourceFolder);

        const watch = this.mediaPlayerFileSystem.watchMediaFileArrived(fontFilePath)
            .subscribe({
                next: async (fileEntry: FileEntry) => {
                    const fileUrl = await FileUtils.getFileUrl(fontFileName, this.sourceFolder);
                    let fontFace = '';
                    fontFace += '@font-face{';
                    fontFace += `font-family: ${generatedName};`;
                    fontFace += "src:url('" + fileUrl + "');";
                    fontFace += '}';
                    document.getElementById(this.styleElementId).append(fontFace);
                }
            });

        this.fontWatchers.push(watch);
        return generatedName;
    }
}